export default __webpack_public_path__ + "static/creditline-afs-2x-434624079ab089b3906b851a7b06d528.png";